module.exports = __webpack_public_path__ + "img/bot_metatrader4_lazy.dce38601.png";